import api from '@/js/services/api';

const REF_STORAGE_KEY = 'referral_code';

/**
 * Stores an incoming ?ref= code from an affiliate link so it survives past
 * login/registration (the click may happen while logged out).
 * */
export const storeReferralCode = (code) => {
  if (!code) return;
  localStorage.setItem(REF_STORAGE_KEY, code);
};

export const getStoredReferralCode = () => localStorage.getItem(REF_STORAGE_KEY);

export const clearStoredReferralCode = () => localStorage.removeItem(REF_STORAGE_KEY);

/**
 * Reports a stored referral code to the backend once the referred user is
 * known (logged in). Safe to call repeatedly - the backend no-ops on
 * self-referral, expired codes and existing active attributions.
 * */
export const recordReferralClick = async (code, referredWallet) => {
  return api.post('tx/v1/affiliate/click', {
    code,
    referred_wallet: referredWallet,
  });
};
